export default {
    list: [],
    item: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/notification/state.js